import Swiper, {
  Pagination
} from 'swiper';

export default class InstallationSlider {

  slideClass = 'jet-listing-grid__item';

  wrapperClass = 'jet-listing-grid__items';

  swiperOptions = {
      modules: [
          Pagination
      ],
      loop: false,
      slidesPerView: 1.2,
      centeredSlides: true,
      spaceBetween: 20,
      wrapperClass: 'swiper-wrapper',
      slideClass: 'swiper-slide',
      pagination: {
          el: '.swiper-pagination',
          clickable: true
      },
  };

  constructor() {
      this.addEvents();
  }

  addEvents() {

      const installationSlider = document.querySelectorAll('.installationSlider');
      if (!installationSlider) return;
      const that = this;

      window.addEventListener('load', e => {
          setTimeout(() => {
            if(document.body.offsetWidth <= 768) {
            installationSlider.forEach((slider) => {
                  const swiperElements = slider.querySelectorAll('.jet-listing-grid');
                  if (!swiperElements) return;
                  swiperElements.forEach((swiperElement) => {
                      // init swiper
                      swiperElement.classList.add('swiper-container');
                      let swiperSlides = swiperElement.querySelectorAll(`.${this.slideClass}`);
                      swiperElement.innerHTML += (`
                          <div class="swiper-pagination relative"></div>
                      `);
                      const swiperWrapper = swiperElement.querySelector(`.${this.wrapperClass}`);
                      swiperWrapper.setAttribute('class', 'swiper-wrapper');

                      swiperSlides = swiperElement.querySelectorAll(`.${this.slideClass}`);
                      swiperSlides.forEach((el) => {
                          el.setAttribute('class', 'swiper-slide');
                      });
                      new Swiper(swiperElement, this.swiperOptions);
                  });
              });
            }
          }, 500)


      });
  }
}
